import React, { useEffect } from "react";
import classNames from "classnames";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Grid,
  Typography,
  Button,
} from "@material-ui/core";
import { 
  withStyles, 
  makeStyles 
} from "@material-ui/core/styles";
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import styles from "assets/jss/material-kit-react/views/profilePage.js";
import { darkBlueColor, yelloColor } from "../../Utils/index";
import fee from "assets/img/fee.png";

const useStyles = makeStyles(styles);

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: darkBlueColor,
    fontSize: 18,
    fontFamily: 'roboto',
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 16,
    fontFamily: 'roboto',
    fontWeight: 500,
    color: darkBlueColor,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {},
  },
}))(TableRow);

export default function Fee(props) {
  const classes = useStyles();
  const { ...rest } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  function createData(sno, name, feesOne, feesTwo, FeesThree) {
    return { sno, name, feesOne, feesTwo, FeesThree };
  }

  const bcaRows = [
    createData(1, "ACE FORM FEES", 100),
    createData(2, "ACE REGISTRATION FEES", "1,400"),
    createData(3, "IDENTITY CARD", 100),
    createData(4, "LIBRARY FEES", "1,000"),
    createData(5, "CAUTION FEES (REFUNDABLE SECURITY)", "1,000"),
    createData(6, "UNIVERSITY FEES (AS PER NORMS)", 850),
    createData(7, "CO-CURRICULAR ACTIVITY FEES", 500),
    createData(8, "SPORTS FEES", 350),
    createData(9, "TUITION FEES", "20,800"),
    createData(10, "INDUSTRIAL VISIT", 300),
    createData(11, "LABORATORY CHARGES", "1,600"),
  ];

  const bcomRows = [
    createData(1, "ACE FORM FEES", 100),
    createData(2, "ACE REGISTRATION FEES", "1,400"),
    createData(3, "IDENTITY CARD", 100),
    createData(4, "LIBRARY FEES", "1,000"),
    createData(5, "CAUTION FEES (REFUNDABLE SECURITY)", "1,000"),
    createData(6, "UNIVERSITY FEES (AS PER NORMS)", 850),
    createData(7, "CO-CURRICULAR ACTIVITY FEES", 500),
    createData(8, "SPORTS FEES", 350),
    createData(9, "TUITION FEES", "14,400"),
    createData(10, "INDUSTRIAL VISIT", "300")
  ];

  const baRows = [
    createData(1, "ACE FORM FEES", 100),
    createData(2, "ACE REGISTRATION FEES", "1,400"),
    createData(3, "IDENTITY CARD", 100),
    createData(4, "LIBRARY FEES", "1,000"),
    createData(5, "CAUTION FEES (REFUNDABLE SECURITY)", "1,000"),
    createData(6, "UNIVERSITY FEES (AS PER NORMS)", 850),
    createData(7, "CO-CURRICULAR ACTIVITY FEES", 500),
    createData(8, "SPORTS FEES", 350),
    createData(9, "TUITION FEES", "10,400"),
    createData(10, "INDUSTRIAL VISIT", "300"),
    createData(11, "LABORATORY CHARGES (*For Geography Only) ", "1,000"),
  ];

  const bscCbzRows = [
    createData(1, "ACE FORM FEES", 100),
    createData(2, "ACE REGISTRATION FEES", "1,400"),
    createData(3, "IDENTITY CARD", 100),
    createData(4, "LIBRARY FEES", "1,000"),
    createData(5, "CAUTION FEES (REFUNDABLE SECURITY)", "1,000"),
    createData(6, "UNIVERSITY FEES (AS PER NORMS)", 850),
    createData(7, "CO-CURRICULAR ACTIVITY FEES", 500),
    createData(8, "SPORTS FEES", 350),
    createData(9, "TUITION FEES", "18,000"),
    createData(10, "INDUSTRIAL VISIT", "300"),
    createData(11, "LABORATORY CHARGES", "2,400"),
  ];

  const bscPcmRows = [
    createData(1, "ACE FORM FEES", 100),
    createData(2, "ACE REGISTRATION FEES", "1,400"),
    createData(3, "IDENTITY CARD", 100),
    createData(4, "LIBRARY FEES", "1,000"),
    createData(5, "CAUTION FEES (REFUNDABLE SECURITY)", "1,000"),
    createData(6, "UNIVERSITY FEES (AS PER NORMS)", 850),
    createData(7, "CO-CURRICULAR ACTIVITY FEES", 500),
    createData(8, "SPORTS FEES", 350),
    createData(9, "TUITION FEES", "20,200"),
    createData(10, "INDUSTRIAL VISIT", "300"),
    createData(11, "LABORATORY CHARGES", "3,300"),
  ];

  return (
    <div>
      <Header
        color="white"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 200,
          color: "white",
        }}
        {...rest}
      />
      <div
        className={classNames(classes.main)}
        style={{ marginTop: 110, backgroundColor: "white" }}
      >
        <div>
          <div className={classes.container} style={{ padding: 30 }}>
            <h2
              style={{
                fontSize: "30px",
                fontFamily: "Rubik, sans-serif",
                fontWeight: "bold",
                color: darkBlueColor,
                marginBottom: 40,
                textAlign: 'center'
              }}
            >
              Fees Structure (JNVU-2026-27)
            </h2>

            <Grid container spacing={5}>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TableContainer component={Paper}>
                  <Table className={classes.table} aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell align="left">Particular <span style={{ color: yelloColor }}>(BCA)</span></StyledTableCell>
                        <StyledTableCell align="center">Fees (₹)</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {bcaRows?.map((row) => (
                        <StyledTableRow key={row.name} style={{ marginTop: 200 }}>
                          <StyledTableCell
                            component="th"
                            scope="row"
                            align="left"
                          >
                            {row.name}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {row.feesOne}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                      <StyledTableRow style={{ backgroundColor: yelloColor }}>
                          <StyledTableCell
                            component="th"
                            align="left"
                            style={{ 
                              fontSize: 18,
                              color: darkBlueColor,
                              fontWeight: 'bold'
                            }}
                          >
                            TOTAL
                          </StyledTableCell>
                          <StyledTableCell 
                            align="center"
                            style={{ 
                              fontSize: 18,
                              color: darkBlueColor,
                              fontWeight: 'bold'
                            }}
                          >
                            28,000
                          </StyledTableCell>
                        </StyledTableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
              
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TableContainer component={Paper}>
                  <Table className={classes.table} aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell align="left">Particular <span style={{ color: yelloColor }}>(B.COM)</span></StyledTableCell>
                        <StyledTableCell align="center">Fees (₹)</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {bcomRows?.map((row) => (
                        <StyledTableRow key={row.name}>
                          <StyledTableCell
                            component="th"
                            scope="row"
                            align="left"
                          >
                            {row.name}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {row.feesOne}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                      <StyledTableRow style={{ backgroundColor: yelloColor }}>
                          <StyledTableCell
                            component="th"
                            align="left"
                            style={{ 
                              fontSize: 18,
                              color: darkBlueColor,
                              fontWeight: 'bold'
                            }}
                          >
                            TOTAL
                          </StyledTableCell>
                          <StyledTableCell 
                            align="center"
                            style={{ 
                              fontSize: 18,
                              color: darkBlueColor,
                              fontWeight: 'bold'
                            }}
                          >
                            20,000
                          </StyledTableCell>
                        </StyledTableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TableContainer component={Paper}>
                  <Table className={classes.table} aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell align="left">Particular <span style={{ color: yelloColor }}>(BA)</span></StyledTableCell>
                        <StyledTableCell align="center">Fees (₹)</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {baRows?.map((row) => (
                        <StyledTableRow key={row.name}>
                          <StyledTableCell
                            component="th"
                            scope="row"
                            align="left"
                          >
                            {row.name}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {row.feesOne}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                      <StyledTableRow style={{ backgroundColor: yelloColor }}>
                          <StyledTableCell
                            component="th"
                            align="left"
                            style={{ 
                              fontSize: 18,
                              color: darkBlueColor,
                              fontWeight: 'bold'
                            }}
                          >
                            TOTAL
                          </StyledTableCell>
                          <StyledTableCell 
                            align="center"
                            style={{ 
                              fontSize: 18,
                              color: darkBlueColor,
                              fontWeight: 'bold'
                            }}
                          >
                            17,000
                          </StyledTableCell>
                        </StyledTableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TableContainer component={Paper}>
                  <Table className={classes.table} aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell align="left">Particular <span style={{ color: yelloColor }}>(BSC-CBZ)</span></StyledTableCell>
                        <StyledTableCell align="center">Fees (₹)</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {bscCbzRows?.map((row) => (
                        <StyledTableRow key={row.name}>
                          <StyledTableCell
                            component="th"
                            scope="row"
                            align="left"
                          >
                            {row.name}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {row.feesOne}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                      <StyledTableRow style={{ backgroundColor: yelloColor }}>
                          <StyledTableCell
                            component="th"
                            align="left"
                            style={{ 
                              fontSize: 18,
                              color: darkBlueColor,
                              fontWeight: 'bold'
                            }}
                          >
                            TOTAL
                          </StyledTableCell>
                          <StyledTableCell 
                            align="center"
                            style={{ 
                              fontSize: 18,
                              color: darkBlueColor,
                              fontWeight: 'bold'
                            }}
                          >
                            26,000
                          </StyledTableCell>
                        </StyledTableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TableContainer component={Paper}>
                  <Table className={classes.table} aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell align="left">Particular <span style={{ color: yelloColor }}>(BSC-PCM)</span></StyledTableCell>
                        <StyledTableCell align="center">Fees (₹)</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {bscPcmRows?.map((row) => (
                        <StyledTableRow key={row.name}>
                          <StyledTableCell
                            component="th"
                            scope="row"
                            align="left"
                          >
                            {row.name}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {row.feesOne}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                      <StyledTableRow style={{ backgroundColor: yelloColor }}>
                          <StyledTableCell
                            component="th"
                            align="left"
                            style={{ 
                              fontSize: 18,
                              color: darkBlueColor,
                              fontWeight: 'bold'
                            }}
                          >
                            TOTAL
                          </StyledTableCell>
                          <StyledTableCell 
                            align="center"
                            style={{ 
                              fontSize: 18,
                              color: darkBlueColor,
                              fontWeight: 'bold'
                            }}
                          >
                            29,000
                          </StyledTableCell>
                        </StyledTableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>

            {/* <div style={{ marginBottom: 50, marginTop: 30 }}>
              <img width={"100%"} height={"100%"} src={fee} />
            </div> */}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
